import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebaseConfig";

/**
 * Fetch all documents from the 'products' collection and return them as an array of objects.
 * @returns {Promise<Array<Object>>} Array of product objects.
 * The Product object will have the following properties:
 * {
        id: "string",
        name: "string",
        link: "string",
        price_change: "string"
        prices: [
            {
                timestamp: "string",
                price: "number"
            },
        ],
        stock: "string"
}
 */
const fetchAllProducts = async () => {
  try {
    const productsCollection = collection(db, "products");
    const productsSnapshot = await getDocs(productsCollection);
    const productsList = productsSnapshot.docs.map((doc) => ({
      id: doc.id, // Get document ID if needed
      ...doc.data(), // Spread the document data
    }));

    // sort the prices array in productsList by product.prices.timestamp
    productsList.forEach((product) => {
      product.prices.sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
      );
    });

    //sort the productsList by the products with the largest prices array lengths
    productsList.sort((a, b) => b.prices.length - a.prices.length);

    return productsList;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export { fetchAllProducts };
